// NGRX
import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
// CRUD
import { QueryParamsModel } from '../../_base/crud';
// Models
import { PatientHeightModel } from '../_models/patient-height.model';

export enum PatientHeightActionTypes {
  PatientHeightOnServerCreated = '[Edit Patient Height Dialog] Patient Height On Server Created',
  PatientHeightCreated = '[Edit Patient Height Dialog] Patient Height Created',
  PatientHeightOnServerUpdated = '[Edit Patient Height Dialog] Patient Height On Server Updated',
  PatientHeightUpdated = '[Edit Patient Height Dialog] Patient Height Updated',
  PatientHeightStatusOnServerUpdated = '[Patient Height List Page] Patient Height Status On Server Updated',
  PatientHeightStatusUpdated = '[Patient Height List Page] Patient Height Status Updated',
  PatientHeightsStatusOnServerUpdated = '[Patient Height List Page] Patient Heights Status On Server Updated',
  PatientHeightsStatusUpdated = '[Patient Height List Page] Patient Heights Status Updated',
  OnePatientHeightOnServerDeleted = '[Patient Heights List Page] One Patient Height On Server Deleted',
  OnePatientHeightDeleted = '[Patient Heights List Page] One Patient Height Deleted',
  ManyPatientHeightsOnServerDeleted = '[Patients List Page] Many Patients On Server Deleted',
  ManyPatientHeightsDeleted = '[Patients List Page] Many Patients Deleted',
  PatientHeightsPageRequested = '[Patient Heights List Page] Patient Heights Page Requested',
  PatientHeightsPageLoaded = '[Patient Heights API] Patient Heights Page Loaded',
  PatientHeightsPageCancelled = '[Patient Heights API] Patient Heights Page Cancelled',
  PatientHeightsPageToggleLoading = '[Patient Heights] Patient Heights Page Toggle Loading',
  PatientHeightActionToggleLoading = '[Patient Heights] Patient Heights Action Toggle Loading',
  ThrowPatientHeightError = '[Patient Heights] Throw Patient Height Error',
  ClearPatientHeightErrors = '[Patient Heights] Clear Patient Height Errors',
}

export class PatientHeightOnServerCreated implements Action {
  readonly type = PatientHeightActionTypes.PatientHeightOnServerCreated;
  constructor(public payload: { patientHeight: PatientHeightModel; id: number }) {}
}

export class PatientHeightCreated implements Action {
  readonly type = PatientHeightActionTypes.PatientHeightCreated;

  constructor(public payload: { patientHeight: PatientHeightModel }) {}
}

export class PatientHeightOnServerUpdated implements Action {
  readonly type = PatientHeightActionTypes.PatientHeightOnServerUpdated;

  constructor(
    public payload: {
      partialPatientHeight: Update<PatientHeightModel>; // For State update
      patientHeight: PatientHeightModel; // For Server update (through service)
    },
  ) {}
}

export class PatientHeightUpdated implements Action {
  readonly type = PatientHeightActionTypes.PatientHeightUpdated;

  constructor(
    public payload: {
      partialPatientHeight: Update<PatientHeightModel>; // For State update
      patientHeight: PatientHeightModel; // For Server update (through service)
    },
  ) {}
}

export class PatientHeightStatusOnServerUpdated implements Action {
  readonly type = PatientHeightActionTypes.PatientHeightStatusOnServerUpdated;

  constructor(
    public payload: {
      patientHeight: PatientHeightModel;
      id: number;
      is_active: boolean;
    },
  ) {}
}

export class PatientHeightStatusUpdated implements Action {
  readonly type = PatientHeightActionTypes.PatientHeightStatusUpdated;

  constructor(
    public payload: {
      patientHeight: PatientHeightModel;
      id: number;
      is_active: boolean;
    },
  ) {}
}

export class PatientHeightsStatusOnServerUpdated implements Action {
  readonly type = PatientHeightActionTypes.PatientHeightsStatusOnServerUpdated;

  constructor(
    public payload: {
      patientHeights: PatientHeightModel[];
      ids: number[];
      is_active: boolean;
    },
  ) {}
}

export class PatientHeightsStatusUpdated implements Action {
  readonly type = PatientHeightActionTypes.PatientHeightsStatusUpdated;

  constructor(
    public payload: {
      patientHeights: PatientHeightModel[];
      ids: number[];
      is_active: boolean;
    },
  ) {}
}

export class OnePatientHeightOnServerDeleted implements Action {
  readonly type = PatientHeightActionTypes.OnePatientHeightOnServerDeleted;

  constructor(public payload: { id: number }) {}
}

export class OnePatientHeightDeleted implements Action {
  readonly type = PatientHeightActionTypes.OnePatientHeightDeleted;

  constructor(public payload: { id: number }) {}
}

export class ManyPatientHeightsOnServerDeleted implements Action {
  readonly type = PatientHeightActionTypes.ManyPatientHeightsOnServerDeleted;

  constructor(public payload: { ids: number[] }) {}
}

export class ManyPatientHeightsDeleted implements Action {
  readonly type = PatientHeightActionTypes.ManyPatientHeightsDeleted;

  constructor(public payload: { ids: number[] }) {}
}

export class PatientHeightsPageRequested implements Action {
  readonly type = PatientHeightActionTypes.PatientHeightsPageRequested;

  constructor(public payload: { page: QueryParamsModel; id: number }) {}
}

export class PatientHeightsPageLoaded implements Action {
  readonly type = PatientHeightActionTypes.PatientHeightsPageLoaded;

  constructor(
    public payload: {
      patientHeights: PatientHeightModel[];
      totalCount: number;
      page: QueryParamsModel;
    },
  ) {}
}

export class PatientHeightsPageCancelled implements Action {
  readonly type = PatientHeightActionTypes.PatientHeightsPageCancelled;
}

export class PatientHeightsPageToggleLoading implements Action {
  readonly type = PatientHeightActionTypes.PatientHeightsPageToggleLoading;

  constructor(public payload: { isLoading: boolean }) {}
}

export class PatientHeightActionToggleLoading implements Action {
  readonly type = PatientHeightActionTypes.PatientHeightActionToggleLoading;

  constructor(public payload: { isLoading: boolean }) {}
}

export class ThrowPatientHeightError implements Action {
  readonly type = PatientHeightActionTypes.ThrowPatientHeightError;

  constructor(public payload: { error: any }) {}
}

export class ClearPatientHeightErrors implements Action {
  readonly type = PatientHeightActionTypes.ClearPatientHeightErrors;
}

export type PatientHeightActions =
  | PatientHeightOnServerCreated
  | PatientHeightCreated
  | PatientHeightOnServerUpdated
  | PatientHeightUpdated
  | PatientHeightStatusOnServerUpdated
  | PatientHeightStatusUpdated
  | PatientHeightsStatusOnServerUpdated
  | PatientHeightsStatusUpdated
  | OnePatientHeightOnServerDeleted
  | OnePatientHeightDeleted
  | ManyPatientHeightsOnServerDeleted
  | ManyPatientHeightsDeleted
  | PatientHeightsPageRequested
  | PatientHeightsPageLoaded
  | PatientHeightsPageCancelled
  | PatientHeightsPageToggleLoading
  | PatientHeightActionToggleLoading
  | ThrowPatientHeightError
  | ClearPatientHeightErrors;
